import React, { useRef, useState, useMemo } from 'react';
import { IoMdCloseCircleOutline } from 'react-icons/io';
import Button from '../../Butten/Button';
import Pinkbtn from '../../Butten/Pinkbtn';
import JoditEditor from 'jodit-react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
const Step = ({
  field,
  handleInput,
  handleEditor,
  index,
  saveImages,
  onDeleteImage,
}) => {
  const editor = useRef(null);
  const [content, setContent] = useState('');
  const uploadImages = id => {
    const imgWindow = document.querySelector(`#${id}`);
    imgWindow.click();
  };
  const config = useMemo(
    () => ({
      readonly: false, // all options from https://xdsoft.net/jodit/docs/,
      placeholder: 'Start typings...',
      uploader: {
        url: `${process.env.REACT_APP_ONLINE_URL}/api/v1/get/preSigned/url`,
      },
      //buttons: 'ul,ol'
    }),
    []
  );

  return (
    <>
      <div
        className="extended-step py-0 m-0 rounded-b-xl "
        style={{ backgroundColor: ' #eceff4' }}
      >
        <div className="main-step-extended flex justify-between">
          <div className="main-for-text   p-2">
            {/* <div className="textarea rounded-xl ">
              <input
                className="outline-0 w-[30vw] h-12 rounded-md p-1 text-xs"
                placeholder="Step Name"
                name={"tableOfContent"}
                value={field.tableOfContent}
                onChange={(event) => handleInput(event, index)}
                rows="auto"
              />
            </div> */}
            <div className="upload-btn  flex justify-between w-[30vw] ">
              <p style={{ color: '#eceff4' }}>.</p>
              <input
                type="file"
                id={`images-${field.id}`}
                onChange={e => saveImages(e, index, field.id)}
                hidden
                multiple
              />
              <button
                onClick={() => uploadImages(`images-${field.id}`)}
                className="border-2 bg-white rounded-md p-1 text-xs
                            "
              >
                Upload Images
              </button>
            </div>
          </div>
          <div className="image-main my-2 mx-8">
            {field.images.map((_img, _index) => (
              <>
                <div className="image-display flex text-sm">
                  <p>{_img.name}</p>
                  <IoMdCloseCircleOutline
                    onClick={() => onDeleteImage(index, _index)}
                    size={10}
                    cursor={'pointer'}
                  />
                </div>
              </>
            ))}
            {/* <div className="image-display flex text-sm">
              <p>image2.jpg</p>
              <IoMdCloseCircleOutline size={10} />
            </div> */}
          </div>
        </div>
        <div className="information mb-0.5 mt-0 p-0 mx-4  ">
          <p className="text-sm font-semibold">information</p>
          {/* <ReactQuill
          theme="snow"
         
          value={content} onChange={setContent}
          /> */}
          <JoditEditor
            ref={editor}
            // onBlur={newContent => setContent(newContent)}
            config={config}
            value={field.information}
            onChange={con => handleEditor(con, index)}
          />
          {/* <textarea
            className=" rounded-md w-[42vw] h-12 outline-0 p-1 text-xs"
            rows="auto"
            placeholder="Enter information "
            name={"information"}
            value={field.information}
            onChange={(event) => handleInput(event, index)}
          ></textarea> */}
        </div>
        <div className="btns flex justify-between  w-[44vw]">
          <div className="dot" style={{ color: '#eceff4' }}>
            .
          </div>
          <div className="btn flex">
            {/* <Button btntext="Cancle" /> */}

            {/* <Pinkbtn onClick={savestep} pbtntext="Save" /> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Step;
